import { brokerLoggedOut, brokerVerificationFailed } from "../broker";

const clearStorage = (store) => (next) => (action) => {
  if (
    action.type === brokerLoggedOut.type ||
    action.type === brokerVerificationFailed.type
  )
    localStorage.clear();

  next(action);
};

export default clearStorage;
